import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useCallback } from 'react';
import { useRecoilValue } from 'recoil';
import { FileClose } from '@/components/Icons/FileClose';
import { LoadingIcon } from '@/components/Icons/LoadingIcon';
import { Retry } from '@/components/Icons/Retry';
import { useSocket } from '@/hooks/useSocket';
import { fileContainsUploadUrlSelector, fileHasUploadErrorSelector, isMobileSelector, } from '@/state/session';
import styles from './FilesCarousel.module.scss';
export const Thumbnail = ({ handleClose, id, preview_url, originalName, fileType, }) => {
    const hasUploadUrl = useRecoilValue(fileContainsUploadUrlSelector(id));
    const hasUploadError = useRecoilValue(fileHasUploadErrorSelector(id));
    const isMobile = useRecoilValue(isMobileSelector);
    const { requestUploadPresignedUrl } = useSocket();
    const handleRequestUploadUrl = useCallback(() => {
        requestUploadPresignedUrl({
            fileId: id,
            originalName,
            fileType,
        });
    }, [requestUploadPresignedUrl, id, originalName, fileType]);
    const handleCloseButton = useCallback((e) => {
        e.preventDefault();
        if (handleClose) {
            handleClose();
        }
    }, [handleClose]);
    const renderIcon = () => {
        if (!hasUploadUrl) {
            return (_jsx("div", { className: styles.center, children: _jsx(LoadingIcon, { size: "small" }) }));
        }
        if (hasUploadError) {
            return (_jsx("div", { className: styles.center, role: "button", onClick: handleRequestUploadUrl, onKeyDown: handleRequestUploadUrl, tabIndex: 0, children: _jsx(Retry, {}) }));
        }
        return null;
    };
    return (_jsxs("div", { className: cn(styles.thumbs, 'keen-slider__slide', {
            [styles.mobile]: isMobile,
            [styles.pointer]: hasUploadError,
        }), children: [_jsx("img", { src: preview_url, alt: originalName, className: cn(styles.image, {
                    [styles.filter]: hasUploadError,
                    [styles.opacity]: hasUploadError || !hasUploadUrl,
                }) }), renderIcon(), hasUploadUrl && (_jsx("span", { className: styles.close, role: "button", onClick: handleCloseButton, onKeyDown: handleCloseButton, tabIndex: 0, children: _jsx(FileClose, {}) }))] }));
};
